import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import screens from '../../screens';
import QueueService from '../../services/QueueService';
import { setModal } from '../../state/actions/modal';
import store from '../../state/store';
import parseQueryString from './parseQueryString';
import updateURL from './updateURL';

var EventEmitter = require('events');

var queryParamProxy = /*#__PURE__*/function (_EventEmitter) {
  _inherits(queryParamProxy, _EventEmitter);

  var _super = _createSuper(queryParamProxy);

  function queryParamProxy() {
    var _this;

    _classCallCheck(this, queryParamProxy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.query = undefined;
    _this.QUERY_PARAM_CHANGE = 'ROUTE_PARAM_CHANGE';
    _this.ROUTE_CHANGE = 'ROUTE_CHANGE';
    _this.m_modalPromise = undefined;
    _this.m_modalPromiseAccept = undefined;
    _this.paramQueue = new QueueService();

    _this.init = function () {
      if (_this.query === undefined) {
        _this.query = parseQueryString();
      }
    };

    _this.updateURL = updateURL;
    _this.enqueueScreens = [screens.DynamicPopups, screens.DailySpin, screens.DailySpinOnboarding, screens.WelcomeBonus, screens.News, screens.LimitedTimeOffer];

    _this.setQueryParams = function (params) {
      var _this$query;

      var isParamsValid = ((_this$query = _this.query) === null || _this$query === void 0 ? void 0 : _this$query.m) !== undefined && params.m !== undefined && _this.query.m !== params.m && _this.enqueueScreens.includes(params.m);

      if (isParamsValid) {
        _this.paramQueue.enqueue(params);

        return;
      }

      _this.processParams(params);
    };

    _this.processParams = function (params) {
      store.dispatch(setModal(params.m));
      _this.query = _objectSpread(_objectSpread({}, _this.query), params);

      for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (value === undefined || value === null) {
          delete _this.query[key];
        }
      }

      _this.updateURL(_this.query);

      _this.emit(_this.QUERY_PARAM_CHANGE, params);

      if (!_this.paramQueue.isEmpty()) {
        var queuedParams = _this.paramQueue.dequeue();

        _this.processParams(queuedParams);
      }
    };

    _this.setQueryParamsWithModalPromise = function (params) {
      _this.m_modalPromise = new Promise(function (resolve) {
        return _this.m_modalPromiseAccept = resolve;
      });

      _this.setQueryParams(params);

      return _this.m_modalPromise;
    };

    _this.navigate = function (navigation, to, params) {
      if (params instanceof Object) {
        _this.setQueryParams(params);
      }

      navigation.navigate(to, params);

      _this.updateURL(_this.query);

      _this.emit(_this.ROUTE_CHANGE);
    };

    _this.findParam = function (get, missingVal) {
      if (_this.query === undefined) return missingVal;
      return _this.query[get] || missingVal;
    };

    _this.getAllParams = function () {
      if (_this.query === undefined) return null;
      return _this.query;
    };

    return _this;
  }

  _createClass(queryParamProxy, [{
    key: "modalPromiseAccept",
    get: function get() {
      // Enforce single use nature of the accept.
      if (typeof this.m_modalPromiseAccept === 'function') {
        var accept = this.m_modalPromiseAccept;
        this.m_modalPromiseAccept = undefined;
        return accept;
      } // If it's undefined, return a no-op to the caller


      return function () {};
    }
    /**
     * Call this method on page load to read query string into memory and initialize modalPromise
     */

  }, {
    key: "isEmpty",
    value: function isEmpty(obj) {
      for (var key in obj) {
        if (!obj.hasOwnProperty) return false;
        if (obj.hasOwnProperty(key)) return false;
      }

      return true;
    }
    /**
     *
     * @param {Object} params Param object
     */

  }]);

  return queryParamProxy;
}(EventEmitter);

var QueryParamProxy = new queryParamProxy();
export default QueryParamProxy;